// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__42w0M","selects":"Documents_selects__mZbJ0"};